import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  open() {
    this.element.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.element.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  // Close modal on escape key
  closeWithKeyboard(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  connect() {
    // Add escape key listener
    document.addEventListener("keydown", this.closeWithKeyboard.bind(this))
  }

  disconnect() {
    // Clean up event listener
    document.removeEventListener("keydown", this.closeWithKeyboard.bind(this))
  }
}
